/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//English (United Kingdom)
export default {
  'company-hub.carousel-extension.card-strip.card.label': 'slide {positionInSet} of {setSize}',
  'company-hub.carousel-extension.carousel-content.extra-small-frame.placeholder-title': 'Add a title',
  'company-hub.carousel-extension.carousel-navigation.pause': 'Pause',
  'company-hub.carousel-extension.carousel-navigation.play': 'Play',
  'company-hub.carousel-extension.carousel-navigation.row-orientation.next': 'Next',
  'company-hub.carousel-extension.carousel-navigation.row-orientation.previous': 'Previous',
  'company-hub.carousel-extension.config-panel.add-frame-cta': 'Add frame',
  'company-hub.carousel-extension.config-panel.field.frames.error.invalid-list': 'Add frames',
  'company-hub.carousel-extension.config-panel.layout.title': 'Choose a layout',
  'company-hub.carousel-extension.config-panel.layouts.frame-above-image.label': 'Text with frame above image',
  'company-hub.carousel-extension.config-panel.layouts.solid-color-background.label': 'Solid colour background',
  'company-hub.carousel-extension.config-panel.layouts.split-design-content.label': 'Split design',
  'company-hub.carousel-extension.config-panel.link.field.label': 'Link',
  'company-hub.carousel-extension.config-panel.lozenge.label.updated': 'UPDATED',
  'company-hub.carousel-extension.config-panel.navigation.progress-circles': 'Progress circles',
  'company-hub.carousel-extension.config-panel.navigation.thumbnails': 'Thumbnails',
  'company-hub.carousel-extension.config-panel.preamble-link.label-v2': 'Learn more about carousels',
  'company-hub.carousel-extension.config-panel.preamble-v2':
    'Design a set of up to {number} rotating frames. {supportLink}',
  'company-hub.carousel-extension.config-panel.preamble-v2-without-support-link':
    'Design a set of up to {number} rotating frames.',
  'company-hub.carousel-extension.config-panel.style.general.title': 'General',
  'company-hub.carousel-extension.config-panel.style.navigation.title': 'Navigation',
  'company-hub.carousel-extension.config-panel.styles.autoplay-label': 'Autoplay',
  'company-hub.carousel-extension.config-panel.styles.autoplay-tooltip-content':
    'Set your carousel to scroll automatically every {number} seconds in view mode',
  'company-hub.carousel-extension.config-panel.tab.content.label': 'Content',
  'company-hub.carousel-extension.config-panel.tab.styles.label': 'Styles',
  'company-hub.carousel-extension.config-panel.title': 'Carousel',
  'company-hub.carousel-extension.description.field.label': 'Description',
  'company-hub.carousel-extension.description.placeholder': 'Customise this frame to create a rotating carousel.',
  'company-hub.carousel-extension.frame-spotlight.label': 'frame {positionInSet} of {setSize}',
  'company-hub.carousel-extension.frame.background.color': 'Background colour',
  'company-hub.carousel-extension.frame.color-contrast.fail':
    'Your text and background colours don’t work well for readability.',
  'company-hub.carousel-extension.frame.color-contrast.success':
    'Your text and background colours work well for readability.',
  'company-hub.carousel-extension.frame.text.color': 'Text colour',
  'company-hub.carousel-extension.hub-element.description': 'A rotating set of beautiful frames',
  'company-hub.carousel-extension.hub-element.title': 'Carousel',
  'company-hub.carousel-extension.manifest.macro-description': 'Create a rotating trio of dynamic frames.',
  'company-hub.carousel-extension.manifest.macro-title': 'Carousel',
  'company-hub.carousel-extension.manifest.macro-title.updated': 'Carousel [Updated]',
  'company-hub.carousel-extension.placeholder.description': 'Customise this frame to create a rotating carousel.',
  'company-hub.carousel-extension.placeholder.title': 'Give your frame a title',
  'company-hub.carousel-extension.recommended.field.label': '(Recommended)',
  'company-hub.carousel-extension.title.field.label': 'Title',
  'company-hub.carousel-extension.title.placeholder': 'Give your frame a title',
};
